module.exports = __webpack_public_path__ + "media/images/banner/wowjapan/en-00530120e32e72832062077bf19c650e.jpg";